import google, { mutators, updateMapTypeMap, verify } from "@churchofjesuschrist/maps-google";
import MapsService from "@churchofjesuschrist/maps-service";
import { removeUndefined } from "@churchofjesuschrist/maps-utils";
let initialized = false;
const defaultOptions = {};
const instances = [];
class StyledMapType {
  constructor(styles, options = {}) {
    if (!initialized) {
      verify();
      construct();
      initialized = true;
    }
    let mapTypeOptions = {
      ...defaultOptions,
      ...removeUndefined(options)
    };
    //TODO: super?
    google.maps.StyledMapType.call(this, styles, mapTypeOptions);
    let {
      mapTypeId,
      map
    } = mapTypeOptions;
    this.setOptions(removeUndefined({
      mapTypeId,
      map
    }));
    instances.push(this);
  }
}
const construct = () => {
  // Object.assign(defaultOptions, { baseMapTypeId: google.maps.MapTypeId.TERRAIN });

  MapsService.getString("maptypes.map").then(results => {
    Object.assign(defaultOptions, {
      name: results
    });
    instances.forEach(instance => {
      if (!instance.getName()) {
        instance.setName(defaultOptions.name);
      }
    });
  });
  Object.setPrototypeOf(StyledMapType.prototype, google.maps.StyledMapType.prototype);
  Object.setPrototypeOf(StyledMapType, google.maps.StyledMapType);
  Object.assign(StyledMapType.prototype, mutators("mapTypeId", "name", "alt", "minZoom", "maxZoom", "map"), (() => {
    return {
      changed: function (key) {
        google.maps.StyledMapType.prototype.changed.call(this, key);
        switch (key) {
          case "map":
          case "mapTypeId":
            updateMapTypeMap(this);
            break;
        }
      }
    };
  })());
};
export default StyledMapType;